import isEmpty from 'lodash/isEmpty'

export default homeCtrl

/** @ngInject */
function homeCtrl(AlertManager, $scope, $stateParams, $window) {
    if (!isEmpty($stateParams.utm_source)) {
        localStorage.utm_source = $stateParams.utm_source
    }
    if (!isEmpty($stateParams.utm_medium)) {
        localStorage.utm_medium = $stateParams.utm_medium
    }
    if (!isEmpty($stateParams.utm_campaign)) {
        localStorage.utm_campaign = $stateParams.utm_campaign
    }

    $scope.alerts = AlertManager.alerts
    $scope.closeAlert = (index) => AlertManager.closeAlert(index)

    $scope.openSelfcareV2 = () => {
        if ($window.location.host.indexOf('local') !== -1) {
            $window.location.href = `https://local.unergie.com:3010`
        } else {
            $window.location.href = `https://${$window.location.host}/v2`
        }
    }
}



// WEBPACK FOOTER //
// ./src/states/home/home.js